import React, { useState } from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'
import classes from './modal.module.sass'

const Modal = ({ open, children }) => (
  <div className={cn(classes.modal, open ? '' : classes.closed)}>
    {children}
  </div>
)

Modal.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.string,
  ]).isRequired,
  open: PropTypes.bool.isRequired,
}

export default Modal
